<form #formRef="ngForm">
	<bb-page-header [backOnMobile]="['/adservices/positions']" [icon]="'columns'" [title]="playout?.name">

		<span class="subtitle"> {{ 'AD_POSITIONS' | translate }}</span>

		<bb-status *ngIf="playout" [(ngModel)]="playout.commercials" name="commercials" [labelOn]="'ENABLE_ADS' | translate" [labelOff]="'DISABLE_ADS' | translate" valueOn="true" valueOff="false"></bb-status>

	</bb-page-header>

	<div class="body-column">

		<div [hasPublicationField]="'vmap'">
			<a class="button" [ngClass]="{'vmap': useVMAP}" (click)="useVMAP = !useVMAP"><span>{{ 'USE_VMAP' | translate }}</span></a>
		</div>

		<div [hidden]="useVMAP" class="adunits">
			<div *ngFor="let adunitType of types; let index = index;" class="adunit">
				<h2>{{ adunitType | translate }}</h2>

				<div class="buttons" [hidden]="adunitRows[adunitType]">
					<a class="button" (click)="createAdunit(adunitType)"><i class="fa fa-plus"></i><span>{{ 'CREATE_NEW_ENTITY' | translate : {entity: (adunitType | translate)} }}</span></a>
					<bb-entity-selector [placeholder]="placeholder" [icon]="'chain'" [entityType]="'adunit'" [ngModel]="adunitRows[adunitType]?.id" [options]="adunitRows[adunitType]"
						(optionSelected)="adunitSelected(adunitType, $event)" (ngModelChange)="adunitRemoved(adunitType)" [filterSet]="adunitFilterSets[adunitType]" [ngModelOptions]="{standalone: true}">
					</bb-entity-selector>
				</div>

				<ng-container *ngIf="adunitRows[adunitType]">
					<div class="adunit-title">
						<span class="title">
							{{ 'AD_UNIT' | translate }}: {{ adunitRows[adunitType]?.data?.title }} {{ adunitRows[adunitType]?.data?.status }}
						</span>
						<a class="adunit-edit pull-right fa fa-pencil" (click)="adunitRows[adunitType].quickEditing = !adunitRows[adunitType]?.quickEditing" [title]="'EDIT_AD_UNIT' | translate"></a>
						<a *ngIf="adunitRows[adunitType]?.id" class="adunit-edit pull-right fa fa-caret-square-o-right" [routerLink]="['/adservices/adunits', adunitRows[adunitType].id, 'general']" title="{{'GO_TO_AD_UNIT' | translate}}"></a>
					</div>
					<div [hidden]="adunitRows[adunitType]?.quickEditing" class="adunit-details">
						<div class="adunit-details-row">
							<span>{{'ENABLED' | translate}}</span>
							<span>
								<i *ngIf="adunitRows[adunitType]?.data?.status !== 'published'" class="fa fa-times red"></i>
								<i *ngIf="adunitRows[adunitType]?.data?.status === 'published'" class="fa fa-check green"></i>
							</span>
						</div>
						<div [ngSwitch]="adunitRows[adunitType]?.data?.playout?.commercialBehaviour" class="adunit-details-row">
							<span>{{'PLAYOUT_COMMERCIAL_BEHAVIOUR' | translate}}</span>
							<span *ngSwitchCase="'Once per load'">{{ 'PLAYOUT_COMMERCIAL_ONCE_PER_LOAD' | translate }}</span>
							<span *ngSwitchCase="'Once per session'">{{ 'PLAYOUT_COMMERCIAL_ONCE_PER_SESSION' | translate }}</span>
							<span *ngSwitchCase="'Once per clip'">{{ 'PLAYOUT_COMMERCIAL_ONCE_PER_CLIP' | translate }}</span>
							<span *ngSwitchDefault></span>
						</div>
					</div>
					<div [hidden]="!adunitRows[adunitType] || !adunitRows[adunitType].quickEditing" class="adunit-details quickedit">
						<adunit-quickedit [isNew]="!!adunitRows[adunitType]?.id" [parentForm]="form" [unlink]="unlink" [noQuickeditService]="unlink" [(row)]="adunitRows[adunitType]"
							(canceled)="adunitRemoved(adunitType)" (unlinked)="adunitRemoved(adunitType)" [index]="index">
						</adunit-quickedit>
					</div>

					<div class="buttons">
						<a class="button" (click)="createLineitem(adunitType)"><i class="fa fa-plus"></i><span>{{ 'CREATE_NEW_LINE_ITEM' | translate }}</span></a>
						<bb-entity-selector [placeholder]="lineitemPlaceholder" [icon]="'chain'" [entityType]="'lineitem'" [ngModel]="lineitemIds[adunitType]"
							(optionSelected)="lineitemSelected(adunitType, $event)" (ngModelChange)="lineitemRemoved(adunitType, $event, index)" [ngModelOptions]="{standalone: true}">
						</bb-entity-selector>
					</div>

					<div class="adunit-title lineitems">
						<span class="title">
							{{ 'LINE_ITEMS' | translate }}
						</span>
					</div>
					<div *ngIf="!lineitemRows[adunitType]?.length" class="adunit-details">
						<p>{{ 'NO_LINE_ITEMS_LINKED' | translate }}</p>
					</div>
					<div *ngFor="let lineitemRow of lineitemRows[adunitType]; let i = index;" class="adunit-details {{ lineitemRow?.quickEditing ? 'quickedit' : '' }}">
						<div [hidden]="lineitemRow?.quickEditing">
							<div class="adunit-details-row" >
								<span class="number">{{ i + 1 }}</span>
								<span class="status">{{ lineitemRow?.data?.title }}</span>
								<span>
									<i *ngIf="lineitemRow?.data?.status !== 'published'" class="fa fa-circle red"></i>
									<i *ngIf="lineitemRow?.data?.status === 'published'" class="fa fa-circle green"></i>
								</span>
								<a class="lineitem-edit pull-right fa fa-pencil" (click)="lineitemRow.quickEditing = !lineitemRow?.quickEditing" title="{{'EDIT_LINE_ITEM' | translate}}"></a>
								<a *ngIf="lineitemRow?.id" class="lineitem-edit pull-right fa fa-th-list" [routerLink]="['/adservices/lineitems', lineitemRow.id, 'settings']" title="{{'GO_TO_LINE_ITEM' | translate}}"></a>
							</div>
							<div class="adunit-details-row">
								<span class="number">&nbsp;</span>
								<span class="status">{{ 'TIMEOUT' | translate }}</span>
								<span>{{ lineitemRow?.data?.timeout }}</span>
							</div>
							<div class="adunit-details-row">
								<span class="number">&nbsp;</span>
								<span class="status">{{ 'VAST_URL' | translate }}</span>
								<span class="vast-url">{{ lineitemRow?.data?.vast_url }}</span>
							</div>
						</div>
						<lineitem-quickedit *ngIf="lineitemRow?.quickEditing" [isNew]="!!lineitemRow?.id" [parentForm]="form" [unlink]="unlink" [noQuickeditService]="unlink" [row]="lineitemRow"
							(canceled)="lineitemRemoved(adunitType, lineitemRow?.id, i)" (unlinked)="lineitemRemoved(adunitType, lineitemRow?.id, i)" [index]="index + '-' + i">
						</lineitem-quickedit>
					</div>

				</ng-container>

			</div>
		</div>

		<div [hidden]="!useVMAP" class="use-vmap">
			<h3><em>{{ 'VMAP' | translate }}</em> {{vmapAdunit?.title}}</h3>
			<p>
				<label>{{'ENABLED' | translate}}</label><br />
				<i class="fa fa-check" [ngClass]="{'red': vmapAdunit?.status === 'draft', 'green': vmapAdunit?.status === 'published'}"></i>
			</p>
			<p>
				<label>{{ 'CODE' | translate }}</label><br />
				<code class="text-only">{{ vmapAdunit?.code }}&nbsp;</code>
			</p>
			<p *ngIf="vmapAdunit?.playout.commercialBehaviour">
				<label>{{ 'PLAYOUT_COMMERCIAL_BEHAVIOUR' | translate }}</label><br />
				<span *ngIf="vmapAdunit?.playout?.commercialBehaviour === 'Once per load'">{{ 'PLAYOUT_COMMERCIAL_ONCE_PER_LOAD' | translate }}</span>
				<span *ngIf="vmapAdunit?.playout?.commercialBehaviour === 'Once per session'">{{ 'PLAYOUT_COMMERCIAL_ONCE_PER_SESSION' | translate }}</span>
				<span *ngIf="vmapAdunit?.playout?.commercialBehaviour === 'Once per clip'">{{ 'PLAYOUT_COMMERCIAL_ONCE_PER_CLIP' | translate }}</span>
			</p>
			<p>
				<label>{{ 'VAST_URL' | translate }}</label><br />
				<code class="url">{{vmapAdunit?.lineitems[0].vast_url || '&nbsp;'}}</code>
			</p>
			<a class="big button" [routerLink]="['/adservices/adunits', (vmapAdunit?.id ? vmapAdunit?.id : 'new-vmap'), 'general']"><i class="fas fa-caret-square-o-right"></i>
				<span>{{ (vmapAdunit?.id ? 'EDIT_VMAP' : 'CREATE_VMAP') | translate }}</span>
			</a>
		</div>
	</div>
</form>

<bb-actions-bar (onSave)="save()" (onCancel)="cancel()" (onDelete)="delete()" [form]="form"></bb-actions-bar>
